export const params = {
  restEndpoints: {
    lead: 'v3/secureonboarding/partner/user/',
    user: 'v3/secureonboarding/partner/user/{customerid}/name/',
    phone: 'v3/secureonboarding/partner/user/{customerid}/phone/',
    ssn: 'v3/secureonboarding/partner/user/',
    address: 'v3/secureonboarding/partner/user/',
    referralOwner: 'v3/public/firstName/',
    login: 'v3/onboarding/user/',
    getIndustry: 'v3/secureonboarding/partner/user/{customerid}/industryList'
  },
  httpHeaders: {
    recaptcha: 'recaptcha',
    auth: 'Authorization'
  },
  responseCodeEnums: {
    INVALID_PHONE_NUMBER: '4010',
    USER_INCORRECT_STATE: '4012',
    REFERRAL_CODE_EXPIRE: '4013',
    INVALID_REFERRAL_CODE: '4015',
    FAILED_KYC: '4017',
    TC_NOT_ACCEPTED: '4018',
    EMAIL_ALREADY_EXISTS: '4041',
    INVALID_SSN_FORMAT: '4023',
    INVALID_EMAIL_FORMAT: '4024',
    USER_LOCKED: '4026',
    MUST_BE_OLDER_THAN: '4028',
    NAME_TOO_LONG: '4094',
    CUSTOMER_ALREADY_REGISTER: '4035',
    FAILED_KYC_CHECKING: '4307',
    FAILED_KYC_MORE_INFO: '4308',
    FAILED_KYC_MORE_INFO_AUTO: '4309',
    INVALID_CITY: '4043',
    INVALID_STATE: '4045',
    INVALID_POSTAL: '4046',
    INVALID_FIRST_NAME: '4047',
    INVALID_LAST_NAME: '4048',
    SSN_ALREADY_EXISTS: '4051',
    INVALID_LINE1: '4052',
    INVALID_LINE2: '4076',
    CAPTCHA_FAILED: '4056',
    CUSTOMER_LEAD_NOT_FOUND: '4057',
    INCORRECT_AGE: '4078',
    PHONE_NUMBER_VOIP: '4302',
    PHONE_NUMBER_LANDLINE: '4304',
    FAILED_KYC_RESUBMIT: '4317',
    FAILED_KYC_PARTNER: '4318',
    FAILED_KYC_RESUBMIT_ADDRESS: '43171',
    FAILED_KYC_RESUBMIT_ADDRESS_PO_BOX: '43172',
    FAILED_KYC_RESUBMIT_ADDRESS_COMMERCIAL: '43173',
    FAILED_KYC_RESUBMIT_ADDRESS_UNADDRESSABLE: '43174',
    FAILED_KYC_RESUBMIT_ADDRESS_PARTNER: '43175',
    NEW_PHONE_EXISTS: '4350',
    PLEASE_WAIT: '5100',
    INVALID_PASSWORD_FORMAT: '40015',
    PASSWORD_TOO_SHORT: '40018',
    PASSWORD_TOO_LONG: '40019',
    PASSWORD_ILLEGAL_REPEAT: '40024',
    PASSWORD_ILLEGAL_NUMERIC: '40027',
    PASSWORD_ILLEGAL_SEQUENCE: '40029',
    MFA_CODE_IS_INVALID: '40032',
    INCORRECT_USER_PASSWORD: '40033',
    INCORRECT_USER_PASSWORD_FOR_BROWSER: '40049',
    CANT_UPDATE_UBO: '40065',
    EMAIL_CHANGE_IS_NOT_ALLOWED: '41195',
    UBO_EMAIL_ALREADY_EXISTS: '41196',
    INVALID_LINE1_PO_BOX: '41197',
    UBO_SSN_ALREADY_EXISTS: '41198',
    BUSINESS_ADDRESS_AGENT: '61001',
    PHONE_NUMBER_NOT_US: '43021',
    BUSINESS_NAME_ILLEGAL_NAME: '80003',
    LLC_INVALID_EIN: '80004',
    LLC_INVALID_STATE: '80005',
    EIN_IS_NOT_SSN: '80010',
    EIN_ALREADY_EXISTS: '80012',
    EIN_NOT_UNIQUE: '80013',
    OWNERSHIP_PERCENT_NOT_VALID: '90223',
    tokenExpired: '401'
  },
  states: [
    {
      id: 'AK',
      title: 'AK'
    },
    {
      id: 'AL',
      title: 'AL'
    },
    {
      id: 'AR',
      title: 'AR'
    },
    {
      id: 'AZ',
      title: 'AZ'
    },
    {
      id: 'CA',
      title: 'CA'
    },
    {
      id: 'CO',
      title: 'CO'
    },
    {
      id: 'CT',
      title: 'CT'
    },
    {
      id: 'DC',
      title: 'DC'
    },
    {
      id: 'DE',
      title: 'DE'
    },
    {
      id: 'FL',
      title: 'FL'
    },
    {
      id: 'GA',
      title: 'GA'
    },
    {
      id: 'HI',
      title: 'HI'
    },
    {
      id: 'IA',
      title: 'IA'
    },
    {
      id: 'ID',
      title: 'ID'
    },
    {
      id: 'IL',
      title: 'IL'
    },
    {
      id: 'IN',
      title: 'IN'
    },
    {
      id: 'KS',
      title: 'KS'
    },
    {
      id: 'KY',
      title: 'KY'
    },
    {
      id: 'LA',
      title: 'LA'
    },
    {
      id: 'MA',
      title: 'MA'
    },
    {
      id: 'MD',
      title: 'MD'
    },
    {
      id: 'ME',
      title: 'ME'
    },
    {
      id: 'MI',
      title: 'MI'
    },
    {
      id: 'MN',
      title: 'MN'
    },
    {
      id: 'MO',
      title: 'MO'
    },
    {
      id: 'MS',
      title: 'MS'
    },
    {
      id: 'MT',
      title: 'MT'
    },
    {
      id: 'NC',
      title: 'NC'
    },
    {
      id: 'NE',
      title: 'NE'
    },
    {
      id: 'NH',
      title: 'NH'
    },
    {
      id: 'NJ',
      title: 'NJ'
    },
    {
      id: 'NM',
      title: 'NM'
    },
    {
      id: 'NV',
      title: 'NV'
    },
    {
      id: 'NY',
      title: 'NY'
    },
    {
      id: 'ND',
      title: 'ND'
    },
    {
      id: 'OH',
      title: 'OH'
    },
    {
      id: 'OK',
      title: 'OK'
    },
    {
      id: 'OR',
      title: 'OR'
    },
    {
      id: 'PA',
      title: 'PA'
    },
    {
      id: 'RI',
      title: 'RI'
    },
    {
      id: 'SC',
      title: 'SC'
    },
    {
      id: 'SD',
      title: 'SD'
    },
    {
      id: 'TN',
      title: 'TN'
    },
    {
      id: 'TX',
      title: 'TX'
    },
    {
      id: 'UT',
      title: 'UT'
    },
    {
      id: 'VT',
      title: 'VT'
    },
    {
      id: 'VA',
      title: 'VA'
    },
    {
      id: 'WA',
      title: 'WA'
    },
    {
      id: 'WI',
      title: 'WI'
    },
    {
      id: 'WV',
      title: 'WV'
    },
    {
      id: 'WY',
      title: 'WY'
    }
  ],
  businessTypes: [
    { id: 'Accounting', title: 'Accounting' },
    { id: 'Art', title: 'Art' },
    { id: 'Beauty', title: 'Beauty' },
    { id: 'Business Consultant', title: 'Business Consultant' },
    { id: 'Caregiving', title: 'Caregiving' },
    { id: 'Cleaning/Housekeeping', title: 'Cleaning/Housekeeping' },
    { id: 'Construction', title: 'Construction' },
    { id: 'Cooking/Food', title: 'Cooking/Food' },
    { id: 'Design', title: 'Design' },
    {
      id: 'Digital Marketing/Social Media',
      title: 'Digital Marketing/Social Media'
    },
    { id: 'Driving/Delivery', title: 'Driving/Delivery' },
    { id: 'Education', title: 'Education' },
    { id: 'Entertainment', title: 'Entertainment' },
    { id: 'Health/Therapy', title: 'Health/Therapy' },
    { id: 'Human Resources', title: 'Human Resources' },
    { id: 'Insurance/Benefits Agent', title: 'Insurance/Benefits Agent' },
    { id: 'Legal', title: 'Legal' },
    { id: 'Maintenance/Repair', title: 'Maintenance/Repair' },
    { id: 'Modeling', title: 'Modeling' },
    { id: 'Photography/Videography', title: 'Photography/Videography' },
    { id: 'Programming/IT', title: 'Programming/IT' },
    { id: 'Real Estate', title: 'Real Estate' },
    { id: 'Retail / E-Commerce', title: 'Retail / E-Commerce' },
    { id: 'Sales', title: 'Sales' },
    { id: 'Security', title: 'Security' },
    { id: 'Sports/Fitness', title: 'Sports/Fitness' },
    { id: 'Translation/Writing', title: 'Translation/Writing' }
  ],
  mainSourceOfIncome: [
    { id: 'LLC', title: 'Single Member LLC (Full-time)' },
    {
      id: 'DBA',
      title: 'Sole Proprietor with DBA (Full-time)'
    },
    { id: 'SSN', title: 'Sole Proprietor (Full-time)' },

    { id: 'Part_Time', title: 'Freelance on the side' },
    {
      id: 'Governmental_Benefits',
      title: 'Government Benefits'
    }
  ],
  paramsCookiesLookup: [
    'utm_campaign',
    'utm_source',
    'utm_medium',
    'utm_content',
    'utm_partner',
    'utm_term',
    'af_c_id',
    'af_adset_id',
    'af_ad_id',
    'af_adset',
    'af_keyword_id',
    'ttclid',
    'CID',
    'gclid',
    '_ga_VYHG5X0XGR'
  ],
  stepVersion: 'embeddedv2'
}



// WEBPACK FOOTER //
// ./src/localData/index.js